module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="effect-name">Image Swap</div>\n<div class="selected-image-region"></div>\n<div class="image-toggle-library-region images"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/properties/ImageToggleEffectPropertiesView.tpl
// module id = 1742
// module chunks = 0